<div class="timecard-dialog-row timecard-date-time-field">
  <bz-date-picker class="flex"
                  size="sm"
                  appBringozIdGenerator="timecardDatePicker"
                  [label]="'Date' | translate"
                  [ariaLabel]="'Date' | translate"
                  [openLabel]="'Open calendar' | translate"
                  [format]="dateFormat"
                  [value]="day()"
                  [min]="minDay()"
                  [max]="maxDay()"
                  (valueChange)="onDayChange($event)">
  </bz-date-picker>

  <app-bringoz-time-dropdown class="flex"
                             [timeStamp]="timeStamp()"
                             [referenceDate]="baseTime()"
                             [zoneId]="zoneId()"
                             (click)="onTimeClick($event)"
                             (timeChange)="timeChange.emit($event)">
  </app-bringoz-time-dropdown>
</div>
